<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div style="margin-bottom: 30px">
                  <img
                    v-bind:src="computeLogo"
                    alt="ConSEL"
                    style="display: block; margin: 0 auto; max-height: 70px; max-width: 100%;"
                  />
                </div>

                <v-form @keyup.native.enter="submit">
                  <v-text-field
                    append-icon="person"
                    name="username"
                    :label="$t('username')"
                    type="text"
                    v-model="model.username"
                    v-validate="'required'"
                    :data-vv-as="$t('username')"
                    :error-messages="errors.collect('username')"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock"
                    name="password"
                    :label="$t('password')"
                    id="password"
                    type="password"
                    v-model="model.password"
                    v-validate="'required'"
                    :data-vv-as="$t('password')"
                    :error-messages="errors.collect('password')"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  type="submit"
                  block
                  color="primary"
                  @click="submit"
                  :loading="loading"
                  >{{ $t("login") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div
        style="bottom: 30px; height: 100px; width: 100%; position: absolute;"
      >
        <v-container fluid>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4 lg4>
              <v-container fluid style="padding: 0">
                <v-layout align-center justify-center>
                  <v-flex xs12 sm8 md4 lg4>
                    <img
                      v-bind:src="computeLogoLka"
                      alt="Łodzka Kolej Aglomeracyjna"
                      style="display: block; margin: 0 10px 0 auto; max-height: 70px; max-width: 100%;"
                    />
                  </v-flex>
                  <v-flex xs12 sm8 md4 lg4 offset-sm1>
                    <img
                      v-bind:src="computeLogoNewag"
                      alt="Newag"
                      style="display: block; margin: 0 auto; max-height: 32px; max-width: 100%;"
                    />
                  </v-flex>
                  <v-flex xs12 sm8 md4 lg4 offset-sm1>
                    <img
                      v-bind:src="computeLogoAksel"
                      alt="Aksel"
                      style="display: block; margin: 0 auto; max-height: 30px; max-width: 100%;"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import { LOGIN } from "@/store/actions.type";
export default {
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    loading: false,
    model: {
      username: "",
      password: ""
    }
  }),
  computed: {
    computeLogo() {
      return "/static/img/logo.png";
    },
    computeLogoLka() {
      return "/static/img/logo_lka.png";
    },
    computeLogoNewag() {
      return "/static/img/logo_serwis.png";
    },
    computeLogoAksel() {
      return "/static/img/logo_aksel.png";
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store
            .dispatch(LOGIN, {
              username: this.model.username,
              password: this.model.password
            })
            .then(() => {
              this.$router.push({ name: "Dashboard" });
            });
        }
      });
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
